<template>
  <v-container class="bottom">
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11 xl10>
        <img :src="img1" style="width:100%;" />
      </v-flex>
    </v-layout>
    <v-layout row>
      <div>
        <v-snackbar
          class="new-alert"
          v-model="alert"
          :timeout="timeout"
          :color="alertType"
          top="top"
        >
          {{this.alertMessage}}
          <v-icon color="white" flat @click="alert = false">close</v-icon>
        </v-snackbar>
      </div>
      <v-flex offset-xs0 offset-md1 offset-lg0 offset-sm0 offset-xl0 md9 lg10 xs12 sm11 xl10>
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12>
          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <h3 style="text-align: left">Ámbitos misionales</h3>
              <v-layout>
                <select class="form-control" id="5" v-model="politica">
                  <option
                    v-for="(item,index) in politicas"
                    :key="index"
                    :value="item"
                  >{{item.nombre}}</option>
                </select>
              </v-layout>
              <br />
              <v-layout>
                <v-flex md12 lg12 xs12 sm12>
                  <table cellpadding="0" cellspacing="0">
                    <thead class="header">
                      <tr>
                        <th style="text-align:left" :class="headers1[0].size">Dimensiones</th>
                        <th style="text-align:left" :class="headers1[1].size">{{politica.nombre}}</th>
                        <th style="text-align:center" :class="headers1[2].size">Acciones</th>
                      </tr>
                    </thead>
                  </table>
                  <div class="tbl-content">
                    <table class="table-bordered" cellpadding="0" cellspacing="0" border="1">
                      <tbody>
                        <tr v-for="(item,index) in ambitos" :key="index">
                          <td style="text-align:left" :class="headers1[0].size">{{item.nombre}}</td>
                          <td
                            style="text-align:left"
                            :class="headers1[1].size"
                          >{{item[politica.path]}}</td>
                          <td style="text-align:center" :class="headers1[2].size">
                            <v-icon
                              :disabled="!$session.getAll().permiso"
                              small
                              class="mr-2"
                              @click="openEditAmbitos(item,index)"
                            >edit</v-icon>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>

    <v-dialog v-model="edit" width="700px" persistent>
      <template v-slot:activator="{ on }"></template>
      <v-card class="new-card">
        <v-card-title>
          <span class="headline">Edita tu ambito de investigación</span>
        </v-card-title>
        <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
          <v-layout row>
            <v-flex md12 lg12 xs12 sm12>
              <label for="sel1">Dimensión</label>
              <input v-model="ambito.nombre" disabled type="text" class="form-control" id="usr" />
            </v-flex>
          </v-layout>
          <br />
          <v-layout row>
            <v-flex md12 lg12 xs12 sm12>
              <label for="comment">{{politica.nombre}}</label>
              <textarea
                rows="5"
                v-model="ambito[politica.path]"
                class="form-control"
                ambitos="2"
                id="comment"
              ></textarea>
            </v-flex>
          </v-layout>
          <br />
        </v-flex>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#ec6a12" flat="flat" @click="edit = false">Cerrar</v-btn>
          <v-btn color="#394049" flat="flat" @click="editAmbito()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>


<script>
import img1 from "../../assets/BANNER_2.png";
import img3 from "../../assets/nuevaasistenciadca.png";
import nube from "../../assets/nube.png";

export default {
  data() {
    return {
      ccValor: "",
      projectEdit: false,
      img3: img3,
      politica: { nombre: "Pertenencia Regional", path: "pertenencia" },
      politicas: [
        { nombre: "Pertenencia Regional", path: "pertenencia" },
        { nombre: "Equidad de género", path: "equidad" },
        { nombre: "Desarrollo sustentable", path: "desarrollo" },
        { nombre: "Interculturalidad", path: "interculturalidad" },
        { nombre: "Internacionalización", path: "internacionalizacion" },
        { nombre: "Región Integrada e Inclusiva", path: "rintegrada" },
        { nombre: "Región Equitativa y de Oportunidades", path: "requitativa" },
        { nombre: "Región Segura", path: "rsegura" },
        { nombre: "Región Limpia y Sustentable", path: "rlimpia" },
        { nombre: "Región Innovadora y Competitiva", path: "rinnovadora" }
      ],
      ambito: "",
      edit: false,
      ambitos: [],
      headers1: [
        {
          text: "Dimensión",
          value: "name",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3"
        },
        {
          text: "Pertenencia regional",
          value: "name",
          size: "col-md-8 col-lg-8 col-sm-8 col-xs-8"
        },

        {
          text: "Acciones",
          value: "desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1"
        }
      ],
      timeout: 4000,
      alertType: "success",
      alertMessage: "",
      alert: false,
      edit: false,
      index: "",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      img1: img1,
      right: null
    };
  },

  created() {
    //TODO: ver que renderizar si x alguna razón hay error
    this.ccValor = this.$session.getAll().ccData.ccValor;
    axios
      .get(
        process.env.ROOT_API +
          "/ambitoConsolidado/allAmbitos?ccValor=" +
          this.ccValor,
        this.auth
      )
      .then(response => {
        this.ambitos = response.data;
        //console.log(this.ambitos);
      })
      .catch(error => {
        console.error(error);
        this.showAlert("error", error);
      });
  },
  methods: {
    finish() {
      this.$router.push({ name: "home" });
      var email = this.$session.getAll().email;

      axios
        .get(
          process.env.ROOT_API + "/etapa/etapaUsuario?email=" + email,
          this.auth
        )
        .then(response => {
          var etapa = response.data;
          etapa.etapa2 = true;
          etapa.etapaFinal = 3;
          if (this.$session.getAll().userType == "PHora") etapa.etapaFinal = 2;
          axios
            .patch(
              process.env.ROOT_API + "/etapa/updateEtapa",
              etapa,
              this.auth
            )
            .then(response => {
              //console.log(response.data);
            })
            .catch(error => {
              console.error(error);
              this.showAlert("error", error);
            });
        })
        .catch(error => {
          console.error(error);
          this.showAlert("error", error);
        });
    },
    showAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.alert = true;
    },
    openEditAmbitos(ambito, index) {
      this.edit = true;
      this.index = index;
      this.ambito = ambito;
      //console.log(this.ambito);
    },

    editAmbito() {
      axios
        .put(
          process.env.ROOT_API + "/ambitoConsolidado/updateAmbito",
          this.ambito,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
        this.showAlert("success", "Ambito " + this.ambito.nombre + " editado");
          this.getAmbitos;
        })
        .catch(error => {
          console.erro(error);
        this.showAlert("error", error);
        });
      this.edit = false;
    }
  }
};
</script>


<style scoped>
.new-alert {
  z-index: 9000;
  width: auto;
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
}

.new-alert .theme--light.v-icon {
  color: #ffffff !important;
}
.image {
  cursor: pointer;
}
.text-mision {
  color: rgb(255, 255, 255);
  font-size: 11px;
}

.titlep {
  color: #ec6a12;
  font-size: 12px;
}

.table2 {
  height: 100px !important;
}

.v-card-new {
  margin-top: 50px;
  margin-bottom: 3%;
  margin-left: 3%;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 0.5%;
  background: #394049 !important;
  height: 230px !important;
  overflow-y: auto;
}

.v-card {
  height: 350px;
  overflow-y: auto;
}

.td-color {
  background: #394049;
  height: 100%;
}

.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}

.font {
  color: white !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}

.pull {
  text-align: justify;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.bottom {
  margin-bottom: 50px !important;
}

.header-fixed {
  width: 100%;
  overflow-y: auto;
  height: 200px !important;
}
.header-fixed > thead,
.header-fixed > thead > tr,
.header-fixed > thead > tr > th {
  display: block;
  text-align: left;
  background: #e47215;
  color: #fff;
}

.header-fixed > thead > tr:after {
  content: " ";
  display: block;
  visibility: hidden;
  clear: both;
}
.header-fixed > tbody {
  overflow-y: auto;
  height: 200px;
  width: 100%;
  background: #394049;
}

.header-fixed > thead > tr > th {
  float: left;
  font-size: 13px;
}

.header-fixed > tbody > tr > td {
  float: left;
  font-size: 18px;
  background: #394049;
}

.td-class {
  vertical-align: middle;
  font-size: 12px;
  background: #394049;
}

.test {
  height: 200px !important;
  overflow-y: auto;
}

.header {
  background: #e47215;
  color: #ffffff;
}
table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.tbl-content {
  height: 320px;
  overflow-y: auto;
  margin-top: 0px;
  background: #f1f1f1;
}
th {
  padding: 20px 15px;
  text-align: left;
  font-weight: 500;
  font-size: 13px;
}
td {
  padding: 15px;
  text-align: left;
  vertical-align: middle;
  font-weight: 300;
  font-size: 12px;
  height: 104px;
  border-bottom: solid 1px rgba(0, 0, 0, 0);
  color: #000000;
}

.text-actividad {
  color: #fff;
  text-align: justify;
}
</style>


// WEBPACK FOOTER //
// src/components/definicionEstrategica/Politicas.vue